export const FETCH_SUCCESS = "UPSALE/FETCH_SUCCESS";
export const TABLE_UPDATE = "UPSALE/TABLE_UPDATE";

const types = {
    DESTROY_FAILED: "UPSALE/DESTROY_FAILED",
    DESTROY_REQUEST: "UPSALE/DESTROY_REQUEST",
    DESTROY_SUCCESS: "UPSALE/DESTROY_SUCCESS",

    FETCH_FAILED: "UPSALE/FETCH_FAILED",
    FETCH_REQUEST: "UPSALE/FETCH_REQUEST",
    FETCH_SUCCESS,

    FETCH_ALL_FAILED: "UPSALE/FETCH_ALL_FAILED",
    FETCH_ALL_REQUEST: "UPSALE/FETCH_ALL_REQUEST",
    FETCH_ALL_SUCCESS: "UPSALE/FETCH_ALL_SUCCESS",

    GET_FAILED: "UPSALE/GET_FAILED",
    GET_REQUEST: "UPSALE/GET_REQUEST",
    GET_SUCCESS: "UPSALE/GET_SUCCESS",

    STORE_FAILED: "UPSALE/STORE_FAILED",
    STORE_REQUEST: "UPSALE/STORE_REQUEST",
    STORE_SUCCESS: "UPSALE/STORE_SUCCESS",

    UPDATE_FAILED: "UPSALE/UPDATE_FAILED",
    UPDATE_REQUEST: "UPSALE/UPDATE_REQUEST",
    UPDATE_SUCCESS: "UPSALE/UPDATE_SUCCESS",

    TABLE_UPDATE,
};

export default types;
